import { h } from '@stencil/core';
import { SUBCATEGORY, tryParse } from '@pes-ui/utils';
export class PesAppSprykerSubcategoryListing {
  constructor() {
    this._showBreadcrumbs = undefined;
    this._subcategoryData = undefined;
    this._subcategoryId = undefined;
    this._countryCode = undefined;
    this._languageCode = undefined;
    this._searchParams = undefined;
    this._isPBS = undefined;
    this._enableCommerceConnector = undefined;
    this._showBuyOnline = undefined;
    this._showDocuments = undefined;
    this._showCompare = undefined;
    this.host = undefined;
    this.showBreadcrumbs = undefined;
    this.subcategoryData = null;
    this.subcategoryId = undefined;
    this.showDocuments = true;
    this.enableCommerceConnector = true;
    this.showBuyOnline = true;
    this.productCtas = undefined;
    this.showCompare = true;
    this.isPBS = true;
    this.searchParams = {};
    this.countryCode = undefined;
    this.languageCode = undefined;
    this.storageName = '';
    this.currentPageStorageKey = '';
  }
  componentWillLoad() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    this.showBreadcrumbs = (_a = tryParse(this._showBreadcrumbs)) !== null && _a !== void 0 ? _a : this.showBreadcrumbs;
    this.subcategoryData = (_b = tryParse(this._subcategoryData)) !== null && _b !== void 0 ? _b : this.subcategoryData;
    this.subcategoryId = (_c = tryParse(this._subcategoryId)) !== null && _c !== void 0 ? _c : this.subcategoryId;
    this.isPBS = (_d = tryParse(this._isPBS)) !== null && _d !== void 0 ? _d : this.isPBS;
    this.countryCode = (_e = tryParse(this._countryCode)) !== null && _e !== void 0 ? _e : this.countryCode;
    this.languageCode = (_f = tryParse(this._languageCode)) !== null && _f !== void 0 ? _f : this.languageCode;
    this.searchParams = (_g = tryParse(this._searchParams)) !== null && _g !== void 0 ? _g : this.searchParams;
    this.enableCommerceConnector = (_h = tryParse(this._enableCommerceConnector)) !== null && _h !== void 0 ? _h : this.enableCommerceConnector;
    this.showBuyOnline = (_j = tryParse(this._showBuyOnline)) !== null && _j !== void 0 ? _j : this.showBuyOnline;
    this.showCompare = (_k = tryParse(this._showCompare)) !== null && _k !== void 0 ? _k : this.showCompare;
    this.showDocuments = (_l = tryParse(this._showDocuments)) !== null && _l !== void 0 ? _l : this.showDocuments;
    this.storageName = `${this.host}${this.countryCode}/${this.languageCode}/`;
    this.currentPageStorageKey = `${SUBCATEGORY}/${this.subcategoryId}`;
  }
  render() {
    var _a, _b, _c;
    const { hmcBanner } = this.subcategoryData.subcategoryListingRanges;
    const { analyticsPageData } = this.subcategoryData.metaTags;
    return (h("pes-app-category-subcategory-listing", { host: this.host, showBreadcrumbs: this.showBreadcrumbs, categoryOrSubcategoryId: this.subcategoryId, showDocuments: this.showDocuments, enableCommerceConnector: this.enableCommerceConnector, showBuyOnline: this.showBuyOnline, showCompare: this.showCompare, breadcrumbs: (_a = this.subcategoryData) === null || _a === void 0 ? void 0 : _a.subcategoryBreadcrumbs, descriptionInfo: (_b = this.subcategoryData) === null || _b === void 0 ? void 0 : _b.subcategoryDescription, listingInfo: (_c = this.subcategoryData) === null || _c === void 0 ? void 0 : _c.subcategoryListingRanges, hmcBannerInfo: hmcBanner, searchParams: this.searchParams, isPBS: this.isPBS, isSubcategoryPage: true, productCtas: this.productCtas, storageName: this.storageName, currentPageStorageKey: this.currentPageStorageKey, analyticsPageData: analyticsPageData }, !this.isPBS && (h("slot", { name: "content-article-slide-carousel", slot: "content-article-slide-carousel" }))));
  }
  static get is() { return "pes-app-spryker-subcategory-listing"; }
  static get encapsulation() { return "shadow"; }
  static get properties() {
    return {
      "_showBreadcrumbs": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-show-breadcrumbs",
        "reflect": false
      },
      "_subcategoryData": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-subcategory-data",
        "reflect": false
      },
      "_subcategoryId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-subcategory-id",
        "reflect": false
      },
      "_countryCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-country-code",
        "reflect": false
      },
      "_languageCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-language-code",
        "reflect": false
      },
      "_searchParams": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-search-params",
        "reflect": false
      },
      "_isPBS": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-is-pbs",
        "reflect": false
      },
      "_enableCommerceConnector": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-enable-commerce-connector",
        "reflect": false
      },
      "_showBuyOnline": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-show-buy-online",
        "reflect": false
      },
      "_showDocuments": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-show-documents",
        "reflect": false
      },
      "_showCompare": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-show-compare",
        "reflect": false
      },
      "host": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "https://www.se.com:9090"
            }],
          "text": "The host of the endpoints."
        },
        "attribute": "host",
        "reflect": false
      },
      "showBreadcrumbs": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines whether to show the breadcrumbs."
        },
        "attribute": "show-breadcrumbs",
        "reflect": false
      },
      "subcategoryData": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TSubcategoryListingData",
          "resolved": "{ configuration: TConfig; subcategoryBreadcrumbs: TBreadcrumbsData; subcategoryDescription: TDescriptionInfo; subcategoryListingRanges: TListingInfo; recentlyViewedConfig: RecentlyViewedConfig; metaTags?: MetaTags; }",
          "references": {
            "TSubcategoryListingData": {
              "location": "import",
              "path": "../pes-app-subcategory/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Main data for subcategory listing page."
        },
        "defaultValue": "null"
      },
      "subcategoryId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "4040"
            }],
          "text": "The ID of the subcategory."
        },
        "attribute": "subcategory-id",
        "reflect": false
      },
      "showDocuments": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines whether to show the documents."
        },
        "attribute": "show-documents",
        "reflect": false,
        "defaultValue": "true"
      },
      "enableCommerceConnector": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines whether to show the commerce connector."
        },
        "attribute": "enable-commerce-connector",
        "reflect": false,
        "defaultValue": "true"
      },
      "showBuyOnline": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines whether to show the buy online."
        },
        "attribute": "show-buy-online",
        "reflect": false,
        "defaultValue": "true"
      },
      "productCtas": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TProductCtas",
          "resolved": "{ buttons: TProductCtasButtons; productProp?: string; }",
          "references": {
            "TProductCtas": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Setup productCtas logic.\nbuttons - predefined CTA buttons.\nproductProp - predefined property of product to find in list."
        }
      },
      "showCompare": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines whether to show the compare."
        },
        "attribute": "show-compare",
        "reflect": false,
        "defaultValue": "true"
      },
      "isPBS": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-p-b-s",
        "reflect": false,
        "defaultValue": "true"
      },
      "searchParams": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TSearchParams",
          "resolved": "{ [x: string]: string; }",
          "references": {
            "TSearchParams": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "defaultValue": "{}"
      },
      "countryCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "fr"
            }],
          "text": "The code of the country of the app."
        },
        "attribute": "country-code",
        "reflect": false
      },
      "languageCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "it"
            }],
          "text": "The code of the language of the app."
        },
        "attribute": "language-code",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "storageName": {},
      "currentPageStorageKey": {}
    };
  }
}
